import { ReactNode } from 'react';
import { HomeV2Layout } from '../home-v2';
import type { TimeOfDayConfig } from '../home-v2/timeOfDayConfig';

interface ActivityLibraryLayoutProps {
  children?: ReactNode;
  timeOfDayConfig: TimeOfDayConfig;
  showAvatar: boolean;
  onCloudClick: () => void;
}

export default function ActivityLibraryLayout({
  children,
  timeOfDayConfig,
  showAvatar,
  onCloudClick,
}: ActivityLibraryLayoutProps) {
  return (
    <HomeV2Layout
      timeOfDayConfig={timeOfDayConfig}
      contentStyle="white-container"
      showNightDecorations={false}
      showMorningGlow={false}
      showCloudLogo
      showAvatar={showAvatar}
      onCloudClick={onCloudClick}
    >
      {children}
    </HomeV2Layout>
  );
}
